export default __webpack_public_path__ + "static/media/bh6.3b1151ce.jpg";